import { action, makeObservable, observable } from 'mobx'

export const MIN_CARD_WIDTH = 190
export const MIN_CARD_TITLE_ROW_HEIGHT = 19
export const CARD_ROW_HEIGHT = 18

export default class DeliveryCalendarCardStore {
  @observable public shouldAlignStatusToEnd: boolean = false

  public constructor() {
    makeObservable(this)
  }

  @action.bound
  public setStatusAlignment(shouldAlignToTheEnd: boolean) {
    this.shouldAlignStatusToEnd = shouldAlignToTheEnd
  }
}
